import { EnumToArrayValues } from '@vestico/utils';

import { i18n } from '@vestico/i18n';

import { Gender } from '../users/constants';

export enum TummyShapeModel {
  Flat = 0,
  Average,
  Curvy,
}

export enum HipShapeModel {
  Straight = 0,
  Average,
  Wide,
}

export enum ShoulderShapeModel {
  Narrow = 0,
  Average,
  Wide,
}

export interface ShapeOption {
  shape: number;
  name: string;
  image: string;
}

export const TummyShapeOptions = (large: boolean): ShapeOption[] => buildTummyShapeOptions(Gender.female, large);
export const BellyShapeOptions = (large: boolean): ShapeOption[] => buildTummyShapeOptions(Gender.male, large);
export const HipShapeOptions = (large: boolean): ShapeOption[] => buildHipShapeOptions(large);
export const ShoulderShapeOptions = (large: boolean): ShapeOption[] => buildShoulderShapeOptions(large);

// Tummy Helper

function buildTummyShapeOptions(gender: Gender, large: boolean): ShapeOption[] {
  const enumArray = EnumToArrayValues(TummyShapeModel) as TummyShapeModel[];
  return enumArray.map((tummyModel) => {
    return {
      shape: tummyModel.valueOf(),
      name: stringForTummyOption(tummyModel, gender),
      image: imagePathForTummyOption(tummyModel, gender, large),
    } as ShapeOption;
  });
}

export function stringForTummyOption(tummy: TummyShapeModel, gender: Gender): string {
  switch (tummy) {
    case TummyShapeModel.Flat:
      return i18n.t('LOC_TUMMY_SHAPE_FLAT', { ns: 'model' });
    case TummyShapeModel.Average:
      return i18n.t('LOC_SHAPE_AVERAGE', { ns: 'model' });
    case TummyShapeModel.Curvy:
      return gender === Gender.female ? i18n.t('LOC_TUMMY_SHAPE_CURVIER', { ns: 'model' }) : i18n.t('LOC_TUMMY_SHAPE_ROUNDER_MALE', { ns: 'model' });
  }
  throw new Error(`Invalid tummy shape option ${tummy}`);
}

function imagePathForTummyOption(tummy: TummyShapeModel, gender: Gender, large: boolean): string {
  const imageIndex = tummy.valueOf() + (large ? 3 : 0);
  return gender === Gender.female ? `tummy-${imageIndex}` : `belly-${imageIndex}`;
}

// Hip Helper

function buildHipShapeOptions(large: boolean): ShapeOption[] {
  const enumArray = EnumToArrayValues(HipShapeModel) as HipShapeModel[];
  return enumArray.map((tummyModel) => {
    return {
      shape: tummyModel.valueOf(),
      name: stringForHipOption(tummyModel),
      image: imagePathForHipOption(tummyModel, large),
    } as ShapeOption;
  });
}

export function stringForHipOption(hip: HipShapeModel): string {
  switch (hip) {
    case HipShapeModel.Straight:
      return i18n.t('LOC_HIP_SHAPE_STRAIGHT', { ns: 'model' });
    case HipShapeModel.Average:
      return i18n.t('LOC_SHAPE_AVERAGE', { ns: 'model' });
    case HipShapeModel.Wide:
      return i18n.t('LOC_HIP_SHAPE_WIDER', { ns: 'model' });
  }
  throw new Error(`Invalid hip shape option ${hip}`);
}

function imagePathForHipOption(hip: HipShapeModel, large: boolean): string {
  const imageIndex = hip.valueOf() + (large ? 3 : 0);
  return `hip-${imageIndex}`;
}

// Shoulder Helper

function buildShoulderShapeOptions(large: boolean): ShapeOption[] {
  const enumArray = EnumToArrayValues(ShoulderShapeModel) as ShoulderShapeModel[];
  return enumArray.map((shoulderModel) => {
    return {
      shape: shoulderModel.valueOf(),
      name: stringForShoulderOption(shoulderModel),
      image: imagePathForShoulderOption(shoulderModel, large),
    } as ShapeOption;
  });
}

export function stringForShoulderOption(shoulder: ShoulderShapeModel): string {
  switch (shoulder) {
    case ShoulderShapeModel.Narrow:
      return i18n.t('LOC_SHOULDER_SHAPE_NARROW', { ns: 'model' });
    case ShoulderShapeModel.Average:
      return i18n.t('LOC_SHAPE_AVERAGE', { ns: 'model' });
    case ShoulderShapeModel.Wide:
      return i18n.t('LOC_SHOULDER_SHAPE_WIDER', { ns: 'model' });
  }
  throw new Error(`Invalid hip shape option ${shoulder}`);
}

function imagePathForShoulderOption(shoulder: ShoulderShapeModel, large: boolean): string {
  const imageIndex = shoulder.valueOf() + (large ? 3 : 0);
  return `shoulder-${imageIndex}`;
}
